
import { computed, defineComponent, onMounted, ref, h } from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import HosterModal from "@/components/hoster/hosterModal.vue";
import HosterResponseModal from "@/components/hoster/hosterResponseModal.vue";
// import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { useStore } from "vuex";
// import  products  from '../products';
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  Module as hosterModule,
  Actions as hosterActions,
} from "@/store/enums/hosterEnums";
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply,
} from "@/store/enums/paramsEnums";

import { NButton, NTag, NSpace, NIcon, NP, NText } from "naive-ui";
import { Pencil, CheckmarkDoneSharp, EyeSharp, Trash, Create } from "@vicons/ionicons5";
import { MdCheckmark } from "@vicons/ionicons4";
import statusModel from "@/core/models/share/status.interface";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";
import inviteDateModel from "@/core/models/hoster/inviteDate.interface";
import inviteInfoModel from "@/core/models/hoster/inviteInfo.interface";
import inviteAvailableTimeInterface from "@/core/models/share/inviteAvailableTime.interface";
import { startOfDay } from "date-fns";
import { FilterMatchMode, FilterOperator } from 'primevue/api';

export default defineComponent({
  components: {
    HosterModal: HosterModal,
    HosterResponseModal: HosterResponseModal,
    Pencil,
    CheckmarkDoneSharp,
    EyeSharp,
    MdCheckmark,
    Create,
    Trash
  },
  setup() {
    const showConfirmModal = ref<boolean>(false);
    const ConfirmMessage = ref<String>("確定刪除");
    let onPositiveData = <inviteEventModel>{};
    const store = useStore();
    const selectedField = ref<string>("selected");
    const showModal = ref(false);
    const showResponseModal = ref(false);
    const showEditModal = ref(false);
    const actionModal = ref("I");
    const loading = ref(true);
    const statusData = computed<Array<statusModel>>(
      () => store.getters[Module.desc + Getters.EventStatuses]
    );
    const statuses = ref(
      [
        'O', 'C', 'X'
      ]
    )
    const filterModel = ref(null)

    // const statuses = statusData.value.map((x) => {
    //   return { value: x.Value, label: x.Name };
    // });


    const hosterTimeRang = computed(
      () => store.getters[Module.desc + Getters.MyHostingTimeRange]
    );
    const d = 86400000;
    const filters = ref({
      'Status': { operator: FilterOperator.OR, constraints: [{ value: null, matchMode: FilterMatchMode.EQUALS }] }
    });

    const data = computed<Array<inviteEventModel>>(
      () => store.getters[Module.desc + Getters.MyHostingEvents]
    );
    if(data.value != undefined){
      loading.value = false;
    }
    const event = ref<inviteEventModel>();

  

    const showModalClose = (msg: any) => {
      showModal.value = msg;
      //console.log(data.value)
    };

    const showResponseModalClose = (msg: any) => {
      showResponseModal.value = msg;
    };

    const showEditModalClose = (msg: any) => {
      showEditModal.value = msg;
    };
    async function onDetail(e: inviteEventModel) {
      
      await store.dispatch(Module.desc + Actions.HandMyHostingEvents);

      await store.dispatch(
        hosterModule.desc + hosterActions.LoadInvitePerson,
        e?.EventHeaderId ?? ""
      );
      await store.dispatch(
        hosterModule.desc + hosterActions.LoadInviteScheduler,
        e?.EventHeaderId ?? ""
      );
      await store.dispatch(
        hosterModule.desc + hosterActions.LoadEventResponse,
        e?.EventHeaderId ?? ""
      );
      await store.dispatch(
        hosterModule.desc + hosterActions.LoadEventSchedularWithCount,
        e?.EventHeaderId ?? ""
      );
      await store.dispatch(
        hosterModule.desc + hosterActions.UpdateResolution,
        e
      );
      
      showResponseModal.value = true;
      
      data.value.filter((a: inviteEventModel) => {
        if(a.EventHeaderId == e.EventHeaderId)
        {
          event.value = a
          return a
        }
      });
      
      await store.dispatch(
        hosterModule.desc + hosterActions.HandHosterAllData,
        event.value
      );
      

      //event.value = e;
    }

    async function onEdit(action: any, e?: inviteEventModel) {
      if (action == "I") {
        let user: string = "";
        let InitData: inviteEventModel = {
          EventHeaderId: "0",
          Title: "",
          Description: "",
          SubmitDueDateUTCDateTime: dayjs( )
            .add(7, "day")
            .add(8, 'hours')
            .startOf("day")
            .toISOString(),
          IntervalMinutes: 120,
          HosterMemberId: user,
          HasReply: ParamHasReply.No,
          Location: "",
          Comment: "",
          Status: ParamEventStatus.Open,
          HeadCount: 1,
          ResponseCount: 0,
          ApplierMemberId: user,
          IsResolution: ParamIsResolution.NotYet,
          TimeOffset: dayjs( ).utcOffset(),
        };
        await store.dispatch(
          hosterModule.desc + hosterActions.HandHosterAllData,
          InitData
        );
      } else {
        await store.dispatch(
        hosterModule.desc + hosterActions.LoadInviteScheduler,
        e?.EventHeaderId ?? ""
      );
        await store.dispatch(
          hosterModule.desc + hosterActions.HandHosterAllData,
          e
        );
        event.value = e;
      }
      actionModal.value = action;
      showModal.value = true;
    }
    function onDelete(e: inviteEventModel) {
      onPositiveData = e;
      ConfirmMessage.value = "確定刪除 會議: " + e.Title + " ?";
      showConfirmModal.value = true;
    }
    async function onPositive() {
      
      onPositiveData.Status = ParamEventStatus.Cancel;
      await store.dispatch(hosterModule.desc + hosterActions.UpdateHosterDate, {
        E: onPositiveData,
        P: [],
        S: [],
      });
    
      await store.dispatch(Module.desc + Actions.HandMyHostingEvents);
      await store.dispatch(
        Module.desc + Actions.UpdateReloadParticipantEventsFlag,
        true
      );
      showConfirmModal.value = false;
    }

    function onNegative() {
      showConfirmModal.value = false;
    }
    function updateDatePicker(e: any) {
      store.dispatch(Module.desc + Actions.HandMyHostingEvents);
    }
    return {
      selectedField,
      data,
      event,
      showModal,
      showResponseModal,
      showEditModal,
      showModalClose,
      showResponseModalClose,
      showEditModalClose,
      pagination: {
        pageSize: 10,
      },
      onEdit,
      onDelete,
      actionModal,
      range: ref(
        computed(() => store.getters[Module.desc + Getters.MyHostingTimeRange])
      ),
      hosterTimeRang,
      showConfirmModal,
      ConfirmMessage,
      onPositive,
      onNegative,
      updateDatePicker,
      format: 'yyyy/MM/dd',
      loading,
      ParamEventStatus,
      statusData,
      dayjs,
      ParamIsResolution,
      onDetail,
      filters,
      statuses,
      filterModel
    };
  },
});
